import styled from "styled-components";
import {createRef, useEffect} from "react";

type Props = {
	to: Date | string
	onEnd: Function
}
export default function Countdown ({to: propTo, onEnd} : Props) {
	const hourRef = createRef<HTMLDivElement>()
	const minutesRef = createRef<HTMLDivElement>()
	const secondsRef = createRef<HTMLDivElement>()

	const to = new Date(propTo)

	useEffect(() => {
		const interval = setInterval(() => {
			const diffMS = to.getTime() - Date.now()
			let diffS = Math.round(diffMS / 1000)

			if (diffMS <= 0) {
				clearInterval(interval)
				onEnd()
				return
			}

			const diffH = Math.floor(diffS / 60 / 60)
			if (diffH > 0) {
				diffS -= diffH * 60 * 60
				hourRef.current!.innerText = diffH.toString()
			} else {
				hourRef.current!.innerText = '0'
			}

			const diffM = Math.floor(diffS / 60)
			if (diffM > 0) {
				diffS -= diffM * 60
				minutesRef.current!.innerText = diffM.toString()
			} else {
				minutesRef.current!.innerText = '0'
			}

			let secs = diffS.toString()
			if (secs.length < 2) {
				secs = '0' + secs
			}
			secondsRef.current!.innerText = secs
		}, 250)
		return () => {
			clearInterval(interval)
		}
	}, [to])

	return <CountdownContainer>
		<Digit>
			<span ref={hourRef}></span><span>h</span>
		</Digit>
		<Digit>
			<span ref={minutesRef}></span><span>m</span>
		</Digit>
		<Digit>
			<span ref={secondsRef}></span><span>s</span>
		</Digit>
	</CountdownContainer>
}

const CountdownContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	text-align: center;
	width: 150px;
	font-size: 20px;
	margin: 0 auto;
`

const Digit = styled.div`
	padding: 0 2px;
`
